import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ROUTE_PATH } from '@core/constants';
import { CorpPrefixGuard } from '@core/guard/corp-prefix.guard';
import { TvStartupGuard } from '@core/guard/tv-startup.guard';
import { TvNotFoundRedirectGuard } from '@core/guard/tv-not-found-redirect.guard';
import { StartupTvComponent } from '@core/components';

export const routes: Routes = [
  {
    path: '',
    children:[
      {
        path: '',
        component: StartupTvComponent
      },{
        path: ROUTE_PATH.TV_STARTUP,
        component: StartupTvComponent
      },{
        path: ROUTE_PATH.CUST_LOGIN,
        loadChildren: () => import('@modules/cust-login/cust-login.module').then(m => m.CustLoginModule),
        canActivate: [TvStartupGuard]
      },{
        path: ROUTE_PATH.CORP_SELECTION,
        loadChildren: () => import('@modules/corp-select/corp-select.module').then(m => m.CorpSelectModule)
      },{
        path: ROUTE_PATH.LOGIN,
        loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule),
        canActivate: [TvStartupGuard]
      },{
        path: ROUTE_PATH.OFFICE_SELECTION,
        loadChildren: () => import('@modules/office-selection/office-selection.module').then(m => m.OfficeSelectionModule),
        canActivate: [CorpPrefixGuard]
      },{
        path: ROUTE_PATH.TV_OFFICE_SELECTION,
        loadChildren: () => import('@modules/tv/office-selection-tv/office-selection-tv.module').then(m => m.OfficeSelectionTvModule),
        canActivate: [TvStartupGuard, CorpPrefixGuard]
      },{
        path: '',
        children: [{
          path: '',
          loadChildren: () => import('@modules/modules.module').then(m => m.ModulesModule),
          canActivate: [CorpPrefixGuard]
        }]
      },{
        path: '**',
        canMatch: [TvNotFoundRedirectGuard],
        loadChildren: () => import('@modules/not-found/not-found.module').then(m => m.NotFoundModule)
      }
    ]
  }
];
const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
